import { render, staticRenderFns } from "./apuracao-por-colaborador.vue?vue&type=template&id=321fabef&scoped=true&"
import script from "./apuracao-por-colaborador.vue?vue&type=script&lang=js&"
export * from "./apuracao-por-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./apuracao-por-colaborador.vue?vue&type=style&index=0&id=321fabef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321fabef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VIcon,VSelect,VTextField})
